module.exports = __webpack_public_path__ + "static/media/tradeLogo.f071f797.png";